module.exports = __webpack_public_path__ + "static/appointment-app-e93ddc3be178672e9a7bef7c270f47f7.png";